import DocumentationButton from "components/DocumentationButton";
import { EmptystateModulesColored, EmptystateVcsColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";
import useTypedContext from "hooks/useTypedContext";
import { VcsProvider } from "types/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

import { VCS_INTEGRATIONS_DOCUMENTATION_LINK } from "./constants";
import SetupButton from "./SetupButton";

const getEmptyStateContent = (provider: VcsProvider) => {
  // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
  switch (provider) {
    case VcsProvider.Blob:
      return {
        icon: EmptystateModulesColored,
        title: "Integrate with your blob storage",
        caption:
          "Spacelift reads source code archives directly from AWS S3 or an S3-compatible object store, so stacks can run without a Git provider.",
      };

    default:
      return {
        icon: EmptystateVcsColored,
        title: "Integrate with your source code provider",
        caption: undefined,
      };
  }
};

const VCSIntegrationsEmpty = ({ provider }: { provider: VcsProvider }) => {
  const { hasEntityCreateAccess } = useTypedContext(SpacesContext);
  const { icon, title, caption } = getEmptyStateContent(provider);

  return (
    <EmptyState title={title} caption={caption} icon={icon}>
      <Box gap="large" justify="center" align="center">
        <DocumentationButton
          to={VCS_INTEGRATIONS_DOCUMENTATION_LINK}
          label="Documentation"
          analyticsPage={AnalyticsPageVCS.VCSIntegrations}
          analyticsProps={{ location: "empty-state" }}
        />

        {hasEntityCreateAccess && <SetupButton provider={provider} />}
      </Box>
    </EmptyState>
  );
};

export default VCSIntegrationsEmpty;
